import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, ArrowRight, MapPin, Globe, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { distributor } from '../../data/mock';

const DistributorCTA = () => {
  return (
    <section className="section bg-black relative overflow-hidden" aria-labelledby="distributor-heading">
      {/* Background Grid */}
      <div className="absolute inset-0 grid-bg opacity-50" />
      
      {/* Accent Gradient */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#00FFD1]/10 rounded-full blur-[150px] pointer-events-none" />

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          {/* Label */}
          <p className="terminal-label text-[#00FFD1] mb-4">
            // Philippine Market
          </p>

          {/* Heading */}
          <h2 id="distributor-heading" className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Transform Your
            <span className="text-[#00FFD1]"> Endoscopy Practice?</span>
          </h2>

          <p className="text-white/60 text-lg mb-10 max-w-2xl mx-auto">
            Connect with our exclusive Philippine distributor for product demonstrations,
            pricing inquiries, and technical consultations.
          </p>

          {/* Distributor Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="bg-[#0a0a0a] border border-[#F08A24]/30 p-8 md:p-10 mb-10 text-left"
          >
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
              <div>
                <p className="terminal-label text-[#F08A24] mb-2 flex items-center gap-2">
                  <MapPin size={14} />
                  {distributor.role}
                </p>
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                  {distributor.name}
                </h3>
                <a
                  href={distributor.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="home-distributor-url-link"
                  className="text-[#F08A24] hover:text-white transition-colors flex items-center gap-2 text-lg"
                >
                  <Globe size={18} />
                  {distributor.displayUrl}
                  <ExternalLink size={14} />
                </a>
              </div>

              <div className="flex flex-col gap-3">
                <a
                  href={distributor.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="home-visit-fms-btn"
                  className="btn-distributor"
                >
                  Visit Website
                  <ExternalLink size={16} />
                </a>
                <Link to="/contact-ph" data-testid="home-send-inquiry-btn" className="btn-secondary">
                  Send Inquiry
                  <ArrowRight size={16} />
                </Link>
              </div>
            </div>
          </motion.div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-8 text-white/40 text-sm font-mono">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-[#00FFD1] rounded-full" />
              <span>Authorized Distributor</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-[#00FFD1] rounded-full" />
              <span>Genuine XION Products</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-[#00FFD1] rounded-full" />
              <span>Local Support</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DistributorCTA;
